const User = {
  queryList: [
    {
      name: 'username',
      label: '账号',
      component: 'input'
    },
    {
      name: 'name',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'identityCard',
      label: '证件号',
      component: 'input'
    },
    {
      name: 'mobile',
      label: '手机号',
      component: 'input'
    },
    {
      name: 'email',
      label: '邮箱',
      component: 'input'
    },
    {
      name: 'status',
      label: '状态',
      component: 'select',
      componentAttr: {
        options: [{
          value: 1,
          label: '启用'
        }, {
          value: 0,
          label: '停用'
        }]
      }
    }
  ],
  urlMap: {
    select: '/sys/user/list',
    update: '/sys/user/saveOrUpdate'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/userEdit'
      }
    }
  ],
  titles: [
    {
      name: 'username',
      label: '账号'
    },
    {
      name: 'name',
      label: '姓名'
    },
    {
      name: 'identityCard',
      label: '证件号'
    },
    {
      name: 'mobile',
      label: '手机号'
    },
    {
      name: 'email',
      label: '电子邮箱'
    },
    {
      name: 'schoolName',
      label: '所属单位'
    },
    {
      name: 'status',
      label: '状态',
      map: {
        0: '停用',
        1: '启用'
      },
      action: {
        label: '更改',
        type: 'request',
        addr: 'update',
        data: {userId: '{userId}', status: '({status}?0:1)'}
      }
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '修改',
          name: 'update',
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/userEdit?{userId}'
        },
        {
          label: '重置密码',
          name: 'resetPwd',
          kind: 'primary',
          type: 'dialog',
          addr: 'systemManage/resetPwd?{userId}&user'
        }
      ]
    }
  ]
}
export default User



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/user.js